/* @ngInject */
export default class ImageService {
  static loadImage (image) { return require('../../../../assets/img/' + image) }
}
